export default __webpack_public_path__ + "6b230c466080757ab53831428b59caf4.svg";